﻿<script>
	import { tick } from "svelte";

	export let id;
	export let label;
	export let sublabel = null;
	export let value;
	export let minvalue = null;
	export let maxvalue = null;
	export let maxlength = null;
	export let minlength = null;
	export let placeholder = null;
	export let disabled = null;
	export let readonly = null;
	export let required = null;
	export let errorMessage = null;

	const handleKeyDown = (e) => {
		if (
			e.key == "Backspace" ||
			e.key == "Delete" ||
			e.key == "ArrowLeft" ||
			e.key == "ArrowRight" ||
			e.key === "Enter"
		) {
			return true;
		}
	};

	const handleKeyPress = (e) => {
		if (e.metaKey || e.altKey || e.ctrlKey || e.key === "Enter") {
			return true;
		}

		if (e.key.match(/\d/)) {
			return true;
		}

		e.preventDefault();
		return false;
	};

	const handlePaste = async (e) => {
		var pastedDigits = e.clipboardData.getData("text").replace(/\D/g, "");
		var start = e.target.selectionStart;
		var end = e.target.selectionEnd;

		var resultingValue = value ? value.substring(0, start) + pastedDigits + value.substring(end) : pastedDigits;

		if (maxlength) resultingValue = resultingValue ? resultingValue.substring(0, maxlength) : "";
		value = resultingValue;

		await tick();
		e.target.setSelectionRange(start, end);

		e.preventDefault();
		return false;
	};
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
<input
	{required}
	{disabled}
	{readonly}
	{maxlength}
	{minlength}
	max={maxvalue}
	min={minvalue}
	{placeholder}
	type="number"
	bind:value
	{id}
	class="form-control"
	on:change
	on:keydown={handleKeyDown}
	on:keypress={handleKeyPress}
	on:paste={handlePaste}
	data-bouncer-message={errorMessage}
/>
